import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { TILE_COLORS, TileIconFrame } from './TileIconFrame';

const TEST_ID = 'Icon-TournamentTile';

/** Tournament program avatar: a trophy on the navy tile. */
export const TournamentTileIcon = ({ size = 'small', width, height }: IconProps) => (
    <TileIconFrame size={size} width={width} height={height} testId={TEST_ID}>
        <path
            d="M14.5 18.6C14.5 17.9925 14.0075 17.5 13.4 17.5H10.6C9.99249 17.5 9.5 17.9925 9.5 18.6V19.1H14.5V18.6ZM15.5 19.2C15.5 19.6971 15.0971 20.1 14.6 20.1H9.4C8.90294 20.1 8.5 19.6971 8.5 19.2V18.6C8.5 17.4402 9.4402 16.5 10.6 16.5H13.4C14.5598 16.5 15.5 17.4402 15.5 18.6V19.2Z"
            fill={TILE_COLORS.outline}
        />
        <path
            d="M6.7 9.9V6.7H5.1V8.4C5.1 9.22843 5.77157 9.9 6.6 9.9H6.7ZM7.7 5.7V10.9H6.6C5.21929 10.9 4.1 9.78071 4.1 8.4V6.6C4.1 6.10294 4.50294 5.7 5 5.7H7.7Z"
            fill={TILE_COLORS.outline}
        />
        <path
            d="M17.3 9.9V6.7H18.9V8.4C18.9 9.22843 18.2284 9.9 17.4 9.9H17.3ZM16.3 5.7V10.9H17.4C18.7807 10.9 19.9 9.78071 19.9 8.4V6.6C19.9 6.10294 19.4971 5.7 19 5.7H16.3Z"
            fill={TILE_COLORS.outline}
        />
        <path
            d="M11.5 16.9V14.6C11.5 14.3239 11.7239 14.1 12 14.1C12.2761 14.1 12.5 14.3239 12.5 14.6V16.9C12.5 17.1761 12.2761 17.4 12 17.4C11.7239 17.4 11.5 17.1761 11.5 16.9Z"
            fill={TILE_COLORS.outline}
        />
        <path
            d="M16.8 9.8C16.8 12.451 14.651 14.6 12 14.6C9.34903 14.6 7.2 12.451 7.2 9.8L7.2 5C7.2 4.77909 7.37909 4.6 7.6 4.6L16.4 4.6C16.6209 4.6 16.8 4.77909 16.8 5V9.8Z"
            fill={TILE_COLORS.glyph}
        />
        <path
            d="M7.7 9.8C7.7 12.1748 9.62518 14.1 12 14.1C14.3748 14.1 16.3 12.1748 16.3 9.8L16.3 5.1L7.7 5.1V9.8ZM6.7 5C6.7 4.50294 7.10294 4.1 7.6 4.1L16.4 4.1C16.8971 4.1 17.3 4.50294 17.3 5L17.3 9.8C17.3 12.7271 14.9271 15.1 12 15.1C9.07289 15.1 6.7 12.7271 6.7 9.8V5Z"
            fill={TILE_COLORS.accent}
        />
        <path
            d="M12 8.2C12.7732 8.2 13.4 8.8268 13.4 9.6C13.4 10.3732 12.7732 11 12 11C11.2268 11 10.6 10.3732 10.6 9.6C10.6 8.8268 11.2268 8.2 12 8.2Z"
            fill={TILE_COLORS.glyph}
        />
        <path
            d="M12 8.7C11.5029 8.7 11.1 9.10294 11.1 9.6C11.1 10.0971 11.5029 10.5 12 10.5C12.4971 10.5 12.9 10.0971 12.9 9.6C12.9 9.10294 12.4971 8.7 12 8.7ZM12 7.7C13.0493 7.7 13.9 8.55066 13.9 9.6C13.9 10.6493 13.0493 11.5 12 11.5C10.9507 11.5 10.1 10.6493 10.1 9.6C10.1 8.55066 10.9507 7.7 12 7.7Z"
            fill={TILE_COLORS.accent}
        />
    </TileIconFrame>
);
TournamentTileIcon.TEST_ID = TEST_ID;
